import React, { useEffect, useRef, useState } from 'react';
import ReactDOM from 'react-dom';
import './popover.styles.scss';

export default function Popover({ anchorRef, children, onClose }) {
    const [style, setStyle] = useState({});
    const popRef = useRef(null);

    useEffect(() => {
        const anchor = anchorRef.current;
        if (!anchor) return;

        const compute = () => {
            const r = anchor.getBoundingClientRect();
            const vw = window.innerWidth;
            const vh = window.innerHeight;

            const estW = Math.min(360, vw - 16);
            const estH = 80;

            let top = r.bottom + 8;
            if (top + estH > vh) top = Math.max(8, r.top - estH - 8);

            let left = r.left + r.width / 2 - estW / 2;
            left = Math.max(8, Math.min(left, vw - estW - 8));

            setStyle({ position: 'fixed', top, left, maxWidth: estW, zIndex: 9999 });

            requestAnimationFrame(() => {
                const el = popRef.current;
                if (!el) return;
                const h = el.offsetHeight;
                let t = r.bottom + 8;
                if (t + h > vh) t = Math.max(8, r.top - h - 8);
                let l = r.left + r.width / 2 - el.offsetWidth / 2;
                l = Math.max(8, Math.min(l, vw - el.offsetWidth - 8));
                setStyle(s => ({ ...s, top: t, left: l }));
            });
        };

        compute();
        window.addEventListener('resize', compute);
        window.addEventListener('scroll', compute, true);
        return () => {
            window.removeEventListener('resize', compute);
            window.removeEventListener('scroll', compute, true);
        };
    }, [anchorRef]);

    useEffect(() => {
        const onEsc = (e) => e.key === 'Escape' && onClose?.();
        document.addEventListener('keydown', onEsc);
        return () => document.removeEventListener('keydown', onEsc);
    }, [onClose]);

    return ReactDOM.createPortal(
        <div ref={popRef} className="fin-popover" role="tooltip" style={style}>
            {children}
        </div>,
        document.body
    );
}